'use client';

import classNames from 'classnames';
import { FC, useState } from 'react';

import { CloseIconXs } from '@lichtblick/icons/svg/close/close-xs';
import { Text } from '@lichtblick/photon/atoms/text/text';
import { TextCTA } from '@lichtblick/ui-components/atoms/TextCTA/TextCTA';

import styles from './coupon-banner.module.scss';
import { CouponField } from './coupon-field';

import { CouponBannerType } from '../../types/storyblok';

export const CouponBanner: FC<CouponBannerType> = ({ couponCode, text, theme }) => {
  const [show, setShow] = useState(true);

  return show ? (
    <aside aria-label="Banner mit Bonuscode" className={classNames(styles.banner, styles[`banner-bg-${theme}`])}>
      <div className={styles.content}>
        <Text>{text}</Text>
        <CouponField couponCode={couponCode} />
      </div>
      <TextCTA
        ariaLabel="Banner schließen"
        as="button"
        className={styles['close-button']}
        icon={<CloseIconXs />}
        onClick={() => setShow(false)}
      />
    </aside>
  ) : null;
};
